const rootElement = document.querySelector('#hb-lp-info-block');
if (rootElement) {
  const accordionButtons = rootElement.querySelectorAll('.js-accordion-btn');
  let lastWidth = window.innerWidth;
  const ANIMATION_SPEED = '0.2s ease-in-out';

  const toggleIcons = (btn, isOpen) => {
    const plus = btn.querySelector('.js-icon-plus');
    const minus = btn.querySelector('.js-icon-minus');
    if (plus && minus) {
      plus.classList.toggle('tw:hidden', isOpen);
      minus.classList.toggle('tw:hidden', !isOpen);
    }
  };

  const openAccordion = (btn) => {
    const content = btn.nextElementSibling;
    if (!content || content.classList.contains('is-open')) return;

    content.style.maxHeight = '0px';
    content.classList.remove('tw:hidden'); 
    
    requestAnimationFrame(() => {
      content.classList.add('is-open');
      content.style.maxHeight = content.scrollHeight + 'px';
    });

    toggleIcons(btn, true);
  };

  const closeAccordion = (btn) => {
    const content = btn.nextElementSibling;
    if (!content || !content.classList.contains('is-open')) return;

    content.style.maxHeight = content.scrollHeight + 'px';
    
    requestAnimationFrame(() => {
      content.style.maxHeight = '0px';
      content.classList.remove('is-open');
    });

    toggleIcons(btn, false);

    const onTransitionEnd = () => {
      if (!content.classList.contains('is-open')) {
        content.classList.add('tw:hidden');
      }
      content.removeEventListener('transitionend', onTransitionEnd);
    };
    content.addEventListener('transitionend', onTransitionEnd);
  };

  const updateLayout = () => {
    const isDesktop = window.innerWidth >= 768;
    accordionButtons.forEach(btn => {
      const content = btn.nextElementSibling;
      if (!content) return;

      if (isDesktop) {
        content.style.maxHeight = 'none';
        content.classList.remove('tw:hidden', 'is-open');
        toggleIcons(btn, true);
      } else {
        if (content.style.maxHeight === 'none' || !content.classList.contains('is-open')) {
          content.style.maxHeight = '0px';
          content.classList.add('tw:hidden');
          content.classList.remove('is-open');
          toggleIcons(btn, false);
        }
      }
    });
  };

  accordionButtons.forEach(btn => {
    const content = btn.nextElementSibling;
    if (content) {
      content.style.overflow = 'hidden';
      content.style.transition = `max-height ${ANIMATION_SPEED}`;
    }

    btn.addEventListener('click', () => {
      if (window.innerWidth >= 768) return;
      const isOpen = content.classList.contains('is-open');
      isOpen ? closeAccordion(btn) : openAccordion(btn);
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth !== lastWidth) {
      lastWidth = window.innerWidth;
      updateLayout();
    }
  });

  const handleHash = () => {
    const hash = window.location.hash;
    if (!hash || window.innerWidth >= 768) return;
    const targetBtn = rootElement.querySelector(hash);
    if (targetBtn) {
      openAccordion(targetBtn);
      setTimeout(() => {
        targetBtn.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  };

  updateLayout();
  handleHash();
  window.addEventListener('hashchange', handleHash);
}
